import { render } from "./Twilio.vue?vue&type=template&id=23714410"
import script from "./Twilio.vue?vue&type=script&lang=js"
export * from "./Twilio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__